import Vue from 'vue'
import VueTypedJs from 'vue-typed-js'
import Vuelidate from 'vuelidate'
import Landing from './views/Landing.vue'
import Impressum from './views/Impressum.vue'
import Datenschutz from './views/Datenschutz.vue'

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/main.css";
import vueSmoothScroll from 'vue2-smooth-scroll'
// import VueAnime from 'vue-animejs';
Vue.use(VueTypedJs)
Vue.use(vueSmoothScroll)
Vue.use(Vuelidate)
Vue.config.productionTip = false
// Vue.use(VueAnime)

const routes = {
  '/landing': Landing,
  '/impressum': Impressum,
  '/datenschutz' : Datenschutz

}

new Vue({
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      return routes[this.currentRoute] || Landing
    }
  },
  render (h) { return h(this.ViewComponent) },
}).$mount('#app')
